import React, { Suspense } from 'react'
import { CallToActionSection } from './cta'
import { TeacherTeam } from './teacher-team'
import { SocialMedias } from '../common/social-medias/SocialMedias'
import { Testimonials } from '../testimonials'
import { ContactSection } from './contact'
import { GetStarted } from './get-started'
import { HowDoesItWork } from './how-lalilo-works'
import { Footer } from '../footer'
import { ModalProvider } from 'styled-react-modal'
import { ModalBackground } from '../modal'
import { FeaturesPage } from './features'
import { useTranslation } from 'react-i18next'
import { DocumentTitle } from '../common/DocumentTitle'

export const Home = () => {
  const [t] = useTranslation('meta')
  return (
    <>
      <DocumentTitle title={t('home_title')} />
      <ModalProvider backgroundComponent={ModalBackground}>
        <SocialMedias />
        <main id="main-content">
          <CallToActionSection />
          <HowDoesItWork />
          <FeaturesPage />
          <Suspense fallback={null}>
            <Testimonials />
          </Suspense>
          <Suspense fallback={null}>
            <TeacherTeam />
          </Suspense>
          <Suspense fallback={null}>
            <ContactSection />
          </Suspense>
          <Suspense fallback={null}>
            <GetStarted />
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </ModalProvider>
    </>
  )
}
